export const RoleConstants = {
  SUPER_ADMIN: "ROLE_FIELDSENSE-SUPER-ADMIN",
  ADMIN: "ROLE_FIELDSENSE-ADMIN",
  TECH: "ROLE_FIELDSENSE-TECH",
};
